<template>
  <div class="block">
    <el-date-picker
      class="date-picker"
      v-model="value"
      type="year"
      value-format="yyyy"
      format="yyyy年"
      placeholder="选择年份"
      @change="onPickerChange">
    </el-date-picker>
    <el-button type="primary" size="mini" style="margin-left: 10px; height:32px" @click="search">查询</el-button>
    <span class="date-type">
      <el-radio-group v-model="radio" size="small" @change="changeDate">
        <el-radio-button v-for="date in datesList" :label="date" :key="date">{{date}}</el-radio-button>
      </el-radio-group>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: '',
      radio: '全部',
      datesList: ['今日', '本月', '全部'],
    };
  },
  methods: {
    pad(num) {
      return num < 10 ? '0' + num : String(num);
    },
    formatDate(date) {
      return (
        date.getFullYear() +
        '-' +
        this.pad(date.getMonth() + 1) +
        '-' +
        this.pad(date.getDate())
      );
    },
    emitSearch(payload) {
      this.$emit('dataSearch', payload);
    },
    changeDate() {
      const now = new Date();
      if (this.radio === '今日') {
        this.value = '';
        this.emitSearch({ day: this.formatDate(now) });
        return;
      }
      if (this.radio === '本月') {
        this.value = String(now.getFullYear());
        this.emitSearch({
          year: now.getFullYear(),
          month: now.getMonth() + 1,
        });
        return;
      }
      this.value = '';
      this.emitSearch({});
    },
    onPickerChange() {
      this.radio = '';
    },
    search() {
      this.radio = '';
      if (this.value) {
        this.emitSearch({ year: this.value });
        return;
      }
      this.emitSearch({});
    },
  },
};
</script>
<style scoped lang="stylus">
.block
  display: flex
  justify-content: flex-end
  align-items: center
  height: 32px
.block/deep/.el-input__icon
  display: flex
  align-items: center
.date-type
  padding-left: 20px
  display: flex
  align-items: center
.date-picker
  width: 140px
  height: 32px
</style>
